import { PortfolioAnalyticsPanel } from './PortfolioAnalyticsPanel'
import { usePortfolioAnalytics } from './usePortfolioAnalytics'

/**
 * `/insights/dashboards/portfolio` (IB-282 View 1) — thin composition root wiring
 * `usePortfolioAnalytics` (the real state) into `PortfolioAnalyticsPanel` (the presentational
 * grid), mirroring `JurisdictionAnalyticsContainer`'s own one-line wire-up shape (View-3 precedent)
 * kept as its own file so this route's own diff in `AppRouter.tsx` stays a one-line addition.
 */
export function PortfolioAnalyticsContainer() {
  const analytics = usePortfolioAnalytics()
  return <PortfolioAnalyticsPanel {...analytics} />
}
